function hasTranslation(info = {}, field, language) {
  const languageData = info[language];
  if (!languageData) {
    return false;
  }
  if (!languageData[field]) {
    return false;
  }
  return true;
}

const Translate = ({ info = {}, field, language }) => {
  if (!hasTranslation(info, field, language)) {
    return null;
  }
  return info[language][field];
};

export default Translate;

export { hasTranslation };
